// sensei-app/client/widgets/WeeklyActivityWidget.widget.js
export default {
    name: "WeeklyActivityWidget",
    type: "ChartWidget", // Uses ChartWidget
    description: "Chart of student activity over the last 7 days.",
    roles: ["student"],
    widget: {
        title: "My Weekly Activity",
        size: "large",
        dataProvider: {
            main: {
                rpc: "StudentRpc.getWeeklyActivity"
            }
        },
        chartType: 'line',
        labelsField: 'date',
        dataField: 'count',
        datasetOptions: {
            label: "Completed Activities",
            tension: 0.4,
            fill: true,
            backgroundColor: 'var(--bs-primary-bg-subtle)', 
            borderColor: 'var(--bs-primary)',             
            pointBackgroundColor: 'var(--bs-primary)',
            pointBorderColor: 'var(--bs-body-bg)',        
            pointHoverRadius: 7,
            pointHoverBackgroundColor: 'var(--bs-primary)',
        },
        options: {
            scales: { 
                y: { beginAtZero: true, ticks: { stepSize: 1, precision: 0 }, grid: { color: 'var(--bs-border-color-translucent)' } }, 
                x: { grid: { display: false } } 
            },
            plugins: { legend: { display: false } }
        }
    }
};